import ReportsPreferencesService from './reports-preferences.ts';

/**
 * Predicate for the per-admin pinned-dashboards settings row. Pins share the
 * reports subject (PINNED_REPORTS_SUBJECT) but live under a distinct predicate
 * so dashboard pins never bleed into the reports home and vice versa.
 */
export const PINNED_DASHBOARDS_PREDICATE = 'pinned-dashboards';

/**
 * Per-admin pinned dashboards — the reports-preferences service pointed at the
 * 'pinned-dashboards' predicate. Same optimistic pin/unpin logic, cap, and
 * per-owner scoping; resolved as `service:dashboards-preferences`
 * (tio-reporting's compat-modules glob registers it by filename), a singleton
 * distinct from `reports-preferences`.
 */
export default class DashboardsPreferencesService extends ReportsPreferencesService {
  protected get pinnedPredicate() {
    return PINNED_DASHBOARDS_PREDICATE;
  }
}
